import { useTranslation } from 'react-i18next';
import { Text } from '@/components/common';
import packageJson from '../../../package.json';

const APP_VERSION = packageJson.version;

/** Small gray version label, e.g. "v1.20.4". Rendered in the wizard footer and settings. */
export function VersionLabel() {
  const { t } = useTranslation('common');
  return (
    <Text size="1" color="gray" align="center">
      {t('version', { version: APP_VERSION })}
    </Text>
  );
}
